import * as yup from "yup";

export const apiKeySchema = yup
  .string()
  .required("API Key is required")
  .matches(
    /^[a-zA-Z0-9]+$/,
    "API Key must contain only alphanumeric characters"
  );

export const apiSecretSchema = yup
  .string()
  .required("API Secret is required")
  .matches(
    /^[a-zA-Z0-9]+$/,
    "API Secret must contain only alphanumeric characters"
  );

export const identifierSchema = yup
  .string()
  .required("Identifier is required");

export const platformSchema = yup
  .string()
  .required("Platform is required");

export const usernameSchema = yup
  .string()
  .required("Username is required");

export const passwordSchema = yup
  .string()
  .required("Password is required")
  .min(8, "Password must be at least 8 characters long")
  .matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+={}\[ \]|\\';:"<,>./?`~])[a-zA-Z0-9!@#$%^&*(){}_+=\[ \]|\\';:"<,>./?`~]{8,}$/,
    "Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character"
  );

export const confirmPasswordSchema = yup
  .string()
  .oneOf([yup.ref("password"), null], "Passwords must match");

export const portSchema = yup
  .number()
  .min(1, "Port must be a positive integer")
  .max(65535, "Port number must be between 1 and 65535");

export const connectionStringsSchema = yup.string();

export const noteSchema = yup.string();

export const otherSchema = yup.string().required("Other is required");

export const nameSchema = yup.string().required("Name is required");

export const descriptionSchema = yup.string();

export const expirySchema = yup
  .date()
  .min(
    new Date(Date.now() + 86400000),
    "Select a date from tomorrow onwards."
  );

export const chooseUserSchema = yup
  .array()
  .min(1, "At least one element is required in the array.");

export const accessTyprSchema = yup
  .string()
  .required("Access type is required")
  .oneOf(
    ["Edit", "View"],
    'Access type must be either "Edit" or "View"'
  );
export const fileSchema = yup
  .mixed()
  .test(
    "fileSize",
    "File size must be less than 200KB",
    (value) => value && value.size <= 1 * 1024 * 1024
  )
  .test(
    "fileType",
    "Unsupported file type",
    (value) =>
      value &&
      [
        "application/x-x509-ca-cert",
        "application/octet-stream",
        "application/txt",
      ].includes(value.type)
  );

export const memberArraySchema1 = yup
  .array()
  .min(1, "At least one element is required in the array.");

export const memberArraySchema2 = yup.array();

export const expiryDate = yup
  .date()
  .min(
    new Date(Date.now() + 86400000),
    "Select a date from tomorrow onwards."
  );

export const pwExpiryDate = yup
  .date()
  .min(
    new Date(Date.now() + 86400000),
    "Select a date from tomorrow onwards."
  );

//write regx Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character
//^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+=|\\';:"<,>./?`~])
